module.exports = __webpack_public_path__ + "static/magic8ball-196d36a8b3037843b001143b80ffe97d.png";